import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Terms of Service | Nirmitee Associates</title>
        <meta name="description" content="Terms of Service of Nirmitee Associates. Read the rules and regulations for using our platform." />
      </Helmet>

      <Header />

      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-8 text-center">
              Terms of Service
            </h1>
            
            <div className="prose prose-lg max-w-none text-muted-foreground">
              <p className="mb-6">
                Welcome to Nirmitee Associates. These terms and conditions outline the rules and regulations for the use of Nirmitee Associates's Website, located at nirmitee.in.
              </p>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-foreground mb-4">1. Acceptance of Terms</h2>
                <p className="mb-4">
                  By accessing this website we assume you accept these terms and conditions. Do not continue to use Nirmitee Associates if you do not agree to take all of the terms and conditions stated on this page.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-foreground mb-4">2. Intellectual Property Rights</h2>
                <p className="mb-4">
                  Unless otherwise stated, Nirmitee Associates and/or its licensors own the intellectual property rights for all material on Nirmitee Associates. All intellectual property rights are reserved. You may access this from Nirmitee Associates for your own personal use subjected to restrictions set in these terms and conditions.
                </p>
                <p className="mb-2">You must not:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Republish material from Nirmitee Associates</li>
                  <li>Sell, rent or sub-license material from Nirmitee Associates</li>
                  <li>Reproduce, duplicate or copy material from Nirmitee Associates</li>
                  <li>Redistribute content from Nirmitee Associates</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-foreground mb-4">3. User Obligations</h2>
                <p className="mb-4">
                  As a user of this website, you agree to use the service only for lawful purposes and in a way that does not infringe the rights of, restrict or inhibit anyone else's use and enjoyment of the website. Prohibited behavior includes harassing or causing distress or inconvenience to any other user, transmitting obscene or offensive content or disrupting the normal flow of dialogue within our website.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-foreground mb-4">4. Limitation of Liability</h2>
                <p className="mb-4">
                  In no event shall Nirmitee Associates, nor any of its officers, directors and employees, be held liable for anything arising out of or in any way connected with your use of this website whether such liability is under contract. Nirmitee Associates, including its officers, directors and employees shall not be held liable for any indirect, consequential or special liability arising out of or in any way related to your use of this website.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-foreground mb-4">5. Disclaimer</h2>
                <p className="mb-4">
                  To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website. Nothing in this disclaimer will:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>limit or exclude our or your liability for death or personal injury;</li>
                  <li>limit or exclude our or your liability for fraud or fraudulent misrepresentation;</li>
                  <li>limit any of our or your liabilities in any way that is not permitted under applicable law.</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-foreground mb-4">6. Governing Law</h2>
                <p className="mb-4">
                  These terms and conditions are governed by and construed in accordance with the laws of India and you irrevocably submit to the exclusive jurisdiction of the courts in Pune, Maharashtra.
                </p>
              </section>

              <p className="text-sm italic mt-12">
                Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsOfService;
